import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import * as _ from 'lodash';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'client-adequation-form',
    templateUrl: './client-adequation-form.component.html',
    styleUrls: ['./client-adequation-form.component.scss'],
    standalone: false
})
export class ClientAdequationFormComponent
  extends EaSubscriptionBuilder
  implements OnInit, OnDestroy
{
  loading: boolean = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor, subscriptionFacade);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    if (this.form.valid) {
      this.loading = true;
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  ngOnDestroy(): void {
    this.loading = false;
  }
}
